import { createApp } from 'vue'

import App from './App.vue'
import router from './router'
import { setupSentry } from './utils/sentry'
import './style.css'

setupSentry()

const app = createApp(App)

app.config.errorHandler = (err: unknown, _instance, info: string) => {
  if (err instanceof Error) {
    console.error('[Vue Error]', err.message, '\n', err.stack, '\nInfo:', info)
  } else {
    console.error('[Vue Error]', err, '\nInfo:', info)
  }
}

app.use(router)
app.mount('#app')
